<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">
          <div class="row" v-if="isAdmin">
            <div class="col-12">
              <div class="float-right mb-4">
                <button class="btn btn-secondary btn-sm" @click="export2Excel">
                  <i class="fas fa-download fa-fw"></i> Download XLS
                </button>
              </div>
            </div>
          </div>
          <h2 class="mt-0 pt-0">
            <i class="fas fa-user text-primary"></i>{{$t('customer.title')}}
            <router-link :to="{ name: 'customers_new' }" class="btn btn-primary float-right">{{$t('customer.button.addnew')}}</router-link>
          </h2>
          <hr>
          <div slot="raw-content" class="table-responsive">
            <paper-table
              :data="customers"
              :columns="columns"
              :column_names="column_names"
              ref="vuetable"
              type="hover"
              edit_route="customers_edit"
              delete_route="customers_delete"
            ></paper-table>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PaperTable from "../../components/PaperTable";
const tableColumns = ["#", "Name", "Document", "Phone", "Email"];

export default {
  components: {
    PaperTable
  },
  computed: {
    ...mapState("customers", {
      customers: "all"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      columns: [...tableColumns],
      column_names: [
        "#",
        this.$t('customer.name'),
        this.$t('customer.document'),
        this.$t('customer.phone'),
        this.$t('customer.email'),
      ]
    };
  },
  mounted() {
    this.$store.dispatch("customers/getAll");
  },
  methods: {
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {
        
        const tHeader = this.columns;//['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = ["#", "name", "document", "phone", "email"];//['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);
        
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('global.repairs') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
<style>
</style>
